import type { MovieRatingBreakdown } from "@/mocks/movies";

const labels: { key: keyof MovieRatingBreakdown; label: string }[] = [
  { key: "story", label: "剧情" },
  { key: "acting", label: "演技" },
  { key: "visual", label: "画面" },
  { key: "music", label: "配乐" },
];

export default function RatingBreakdown({ data }: { data: MovieRatingBreakdown }) {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
      <div className="flex items-center gap-2 mb-5">
        <span className="w-1.5 h-5 rounded-full bg-accent-500"></span>
        <h2 className="text-lg font-heading font-bold text-foreground-950">分项评分</h2>
      </div>
      <div className="space-y-4">
        {labels.map((item) => {
          const value = data[item.key];
          return (
            <div key={item.key} className="flex items-center gap-4">
              <span className="w-10 text-sm text-foreground-600 shrink-0">{item.label}</span>
              <div className="flex-1 h-2 rounded-full bg-background-200 overflow-hidden">
                <div
                  className="h-full rounded-full bg-accent-500"
                  style={{ width: `${(value / 10) * 100}%` }}
                ></div>
              </div>
              <span className="w-10 text-right text-sm font-semibold text-foreground-900 shrink-0">
                {value.toFixed(1)}
              </span>
            </div>
          );
        })}
      </div>
      <p className="mt-5 text-xs text-foreground-400">
        以上分项评分为演示数据，仅用于展示评分结构，不代表真实评价。
      </p>
    </div>
  );
}